import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setKeyValue } from "../../../../store/tasks/slice";

const TaskCard = ({
  task,
  index,
  columnId,
  isDragging,
  onDragStart,
  onDrop,
}) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const dispatch = useDispatch();

  const handleDragStart = useCallback(
    (e) => {
      e.stopPropagation();
      onDragStart(task.id, columnId, index);
    },
    [onDragStart, task.id, columnId, index],
  );

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  }, []);

  const handleDragLeave = useCallback(() => setIsDragOver(false), []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragOver(false);
      onDrop(columnId, index);
    },
    [onDrop, columnId, index],
  );

  const handleClick = useCallback(() => {
    dispatch(setKeyValue({ value: task, key: "selectedTask" }));
  }, [task]);

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
    >
      {isDragOver && <div className="task-placeholder" />}
      <div className={`task-card${isDragging ? " task-card--dragging" : ""}`}>
        <span className="task-card__name">
          <span className="task-card__id">#{task.display_id}</span>
          {task.title}
        </span>
      </div>
    </div>
  );
};

export default TaskCard;
